<template>
  <div class="bind-phone">
    <!-- 头部-->
    <div class="fr bg_white" style="height: 100px">
      <div class="header fr ac">
        <img class="cursor logo-img" @click="go('/home/index')" src="/static/imgs/home/logo.png" alt/>
        <div class="ml30 fz30">欢迎登录</div>
      </div>
    </div>

    <!--    中间-->

    <div class="main">
      <div class="blue fz24 mt40 bold">欢迎登陆，请绑定手机号！</div>

      <div class="welcome fr ac mt40 p20">
        <template v-if="!is_Empty(memberInfo) && !is_Empty(memberInfo.member_img)">
          <img class="member-img" :src="memberInfo.member_img || ''" alt/>
        </template>
        <div class="ml30">hi，{{ is_Empty(memberInfo) ? "" : memberInfo.member_nick_name }}，欢迎来到益发商城，完成绑定后可以微信一键登录哦!
        </div>
      </div>

      <div class="fc jc ac">
        <div class="fr ac phone mt40">
          <img class="icon-phone" src="/static/imgs/login/phone.png" alt/>
          <input v-model="member_account" placeholder="手机号" class="pl10" type="number"/>

        </div>
        <div class="fr ac mt30">
          <div class="check-code fr ac">
            <img class="icon-code" src="/static/imgs/login/verificationCode.png" alt/>
            <input v-model="code" placeholder="验证码" class="pl10" type="number"/>
          </div>
          <div class="check-code-btn ml10 fz12 cursor" @click="getCheckCode">
            {{ is_time ? `${count_down}s` : '获取验证码' }}
          </div>
        </div>

        <div class="fr jc ac mt50">
          <div @click="submit" class="login-btn center white cursor">完成</div>
        </div>
      </div>
    </div>

    <!--  底部  -->
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import FooterBar from "../../components/FooterBar";

let timer = null;
export default {
  data() {
    return {
      memberInfo: null,
      member_account: "",
      code: "",
      is_count_down: false,
      is_time: false,
      count_down: 120
    };
  },
  mounted() {
    if (this.is_Empty(this.$store.state.memberInfo)) {
      this.redirect('/login')
    }
    this.memberInfo = this.$store.state.memberInfo;
  },
  methods: {
    //    获取验证码
    getCheckCode() {
      if (this.is_time) {
        this.$message("验证码已发送！");
        return;
      }
      if (this.member_account.length != 11) {
        this.$message("请输入正确的手机号");
        return;
      }

      let param = {
        mobile: this.encrypt(this.member_account),
        code_type: this.encrypt("binding_mobile")
      };

      this.post("settingInterfaces/v1.0/sendAliCode", param).then(res => {
        this.$message.success('已发送验证码！')
        //    获取验证码成功
        this.is_time = true;
        timer = setInterval(() => {
          this.count_down--;
          if (this.count_down === 0) {
            this.count_down = 120;
            this.is_time = false;
            clearInterval(timer);
          }
        }, 1000);
      });
    },

    //  提交
    submit() {
      let param = Object.assign({}, this.memberInfo);
      if (this.is_Empty(param.weixin_pc_openid)) {
        this.$message("openid为空");
        return;
      }
      if (this.is_Empty(this.member_account)) {
        this.$message("手机号为空");
        return;
      }

      if (this.is_Empty(this.code)) {
        this.$message("验证码为空");
        return;
      }
      let obj = {
        weixin_pc_openid: param.weixin_pc_openid,
        member_account: this.member_account,
        code: this.code,
        member_nick_name: param.member_nick_name,
        member_img: param.member_img
      };
      this.post("memberInterfaces/v1.0/wxPcBindMobile", obj).then(res => {
        this.memberInfoInit(res.data)
        // sessionStorage.setItem("memberInfo", JSON.stringify(res.data));
        //判断有没有阅读过注册协议  如果没有阅读过 跳转协议页面
        this.go("/protocol?html_id=1");
      });
    }
  },
  components: {
    "footer-bar": FooterBar
  }
};
</script>

<style scoped lang="scss">
.bind-phone {
  width: 100%;

  .header {
    width: 1200px;
    margin: 0 auto;

    .logo-img {
      width: 114px;
      height: 60px;
    }
  }

  .main {
    width: 1200px;
    margin: 20px auto;
    background-color: #fff;
    padding: 20px 250px;

    .member-img {
      width: 48px;
      height: 48px;
      border-radius: 50%
    }

    .check-code {
      width: 215px;
      height: 44px;
      border: 1px solid rgb(153, 153, 153);
      overflow: hidden;

      input {
        height: 100%;
      }

      .icon-code {
        width: 30px;
        height: 30px;
        margin-left: 8px
      }

    }

    .icon-phone {
      width: 30px;
      height: 30px;
      margin-left: 8px
    }


  }

  .welcome {
    width: 100%;
    height: 85px;
    background: rgb(242, 242, 242);
  }

  .phone {
    width: 320px;
    height: 44px;
    border: 1px solid rgb(153, 153, 153);
  }


  .check-code-btn {
    width: 99px;
    height: 44px;
    background: rgb(69, 142, 246);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }

  .login-btn {
    width: 324px;
    height: 44px;
    background: rgb(69, 142, 246);
    border-radius: 4px;
  }
}

</style>


// WEBPACK FOOTER //
// src/page/login/bind-phone.vue